module.exports = __webpack_public_path__ + "static/media/advertisers_section2_mobile.864b692f.png";